import React, { useContext } from 'react';
import { Container, Row, Modal } from 'react-bootstrap';
import toast from 'react-hot-toast';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';
import BookingForm from './component/Booking/components/BookingForm';
import { BookingContext } from '../../../context/BookingContext';
import AddTrip from './component/Booking/components/AddTrip';
import { AuthContext } from '../../../context/AuthContext';
import { GlobalContext } from '../../../context/GlobalContext';




const Meal = () => {
const {
 MealBookingData, setMealBookingData, showAddTripModal, setShowAddTripModal, paxs, setPaxs,
} = useContext(BookingContext);
const { apiGlobal } = useContext(GlobalContext);
const { agentId, userId } = useContext(AuthContext);


const hidetripmodalHandler = () => {
  setMealBookingData(prevState => ({
    ...prevState,
    showMealBookingModal: true,
  }));
  setShowAddTripModal(false);
};

// handle trip Add
const handletripAdd = async (values) => {
  const utcStartDate = values.startDate;
  const utcEndDate = values.endDate;

     // Convert to IST
     const startDate = new Date(utcStartDate);
     const endDate = new Date(utcEndDate);

     if (startDate >= endDate) {
             toast.error('Start date must be earlier than end date');
             return; // Or any other action you'd like to perform
           }
 
     // IST offset is +5:30
    const istOffset = 5.5 * 60 * 60 * 1000;
    const startDateIST = new Date(startDate.getTime() + istOffset);
    const endDateIST = new Date(endDate.getTime() + istOffset); 
    
    // Format the dates (DD-MM-YYYY)
    const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1)
     .padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
 
 
 const formattedStartDate = formatDate(startDateIST);
 const formattedEndDate = formatDate(endDateIST);
 
    if (Object.keys(paxs).length === 0) {
     toast.error('Please add at least one Pax details');
     return;
    }
  

 const formattedValues = {
  pax_details: paxs,
};

if (!values.triptype) {
   toast.error('Please Select Trip type (Family,Group)');
   return;
}

const formattedPaxDetails = JSON.stringify(formattedValues);
  const formData = new FormData();
  formData.append('agent_id', agentId);
  formData.append('name', values.tripname);
  formData.append('start_date', formattedStartDate);
  formData.append('end_date', formattedEndDate);
  formData.append('trip_type', values.triptype);
  formData.append('trip_ref_no', values.ref_no);
  formData.append('pax_details', formattedPaxDetails);

  formData.append('type', 1);
  formData.append('user_id', userId);
  
    
try {
  // Send POST request with form data
  const response = await fetch(`${apiGlobal}/agent/trip_add.php`, {
    method: 'POST',
    // headers: {
    //   'Content-Type': 'application/json',
    // },
    body: formData, 
  });

  if (response.ok) {
    const data = await response.json(); // Parsing the response JSON
    if (data.status && data.message === 'Success') {
      toast.success('Trip added successfully...');
      setPaxs([]);
      hidetripmodalHandler();
    }
  } else {
    // Handle non-200 responses
    console.error('Error:', response.statusText);
    toast.error('Something went wrong while adding paxs');
  }
} catch (error) {
  // Catch any network or other errors
  console.error('Error during fetch:', error);
}
};



  
  return (
   
    <div>
      <Container>
        <Breadcrumbs 
          aria-label="breadcrumb"
          style={{
          marginLeft: '15px',
          marginBottom: '5px',
        }}
        >
          <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
          <Typography sx={{ color: 'text.primary' }}>Meal</Typography>
          <Typography sx={{ color: 'text.primary' }}>Search</Typography>
        </Breadcrumbs>
        <DefaultTabsBorderedBottom />
        {/* <BookingForm handleAddPayment={handleBookingSubmit} /> */}
      </Container>
      <div>
        <Modal
          show={MealBookingData.showMealBookingModal === true}
          onHide={() => setMealBookingData(prevState => ({
          ...prevState,
          showMealBookingModal: false,
        }))}        
          fullscreen
          backdrop="static" // Prevent clicking outside the modal to close it
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Make Booking</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BookingForm 
              mealName={MealBookingData?.mealname}
              resName={MealBookingData?.restaurantname}
              price={MealBookingData?.finalprice}
              id={MealBookingData?.id}
              mealOffereds={MealBookingData?.mealOffereds}
              locations={MealBookingData?.locations}
              format={MealBookingData?.format}
              setMealBookingData={setMealBookingData}
            />
          </Modal.Body>
        </Modal>
        {/* Modal for Add Trip */}
        <Modal
          show={showAddTripModal}
          onHide={hidetripmodalHandler}
          centered
          size="xl"
          backdrop="static" // Prevent clicking outside the modal to close it
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Add Trip</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddTrip onSubmit={handletripAdd} />
          </Modal.Body>
        </Modal>
      </div>
    </div>
    );
}; 
export default Meal;
